// Return null for dynamic blocks - rendering handled server-side
export default function save() {
    return null;
}
